import React, {FC} from 'react';

interface TagNameProps extends React.HTMLAttributes<HTMLOrSVGElement> {
  tagName?: number;
  className?: string;
  isTitle?: boolean;
}

export enum Tags {
  'h1' = 1,
  'h2' = 2,
  'h3' = 3,
  'h4' = 4,
  'h5' = 5,
  'h6' = 6,
  'p' = 7,
}

const TagName: FC<TagNameProps> = ({tagName, isTitle, ...otherProps}) => {
  const tagNumber = tagName ? tagName : isTitle ? 2 : 7;
  const Tag = Tags[tagNumber] as keyof JSX.IntrinsicElements;
  return <Tag {...otherProps} />;
};

export default TagName;
